<htx-button variant="tertiary" icon="arrow_back" (click)="goBack()">
  {{ 'button.back' | transloco }}
</htx-button>

<article class="legal-container" *transloco="let t; prefix: 'imprint'">
  <h1 class="legal-title">{{ t('title') }}</h1>

  <section class="legal-section">
    <h2 class="legal-h2">Angaben gemäß § 5 TMG</h2>
    <p>
      [Firmenname]<br />
      [Straße und Hausnummer]<br />
      [PLZ Ort]<br />
      Deutschland
    </p>
  </section>

  <section class="legal-section">
    <h2 class="legal-h2">Vertreten durch</h2>
    <p>[Name der vertretungsberechtigten Person(en), z. B. Geschäftsführer]</p>
  </section>

  <section class="legal-section">
    <h2 class="legal-h2">Kontakt</h2>
    <p>
      Telefon: [+49 ...] <br />
      E-Mail: [kontakt&#64;beispiel.de]
    </p>
  </section>

  <section class="legal-section">
    <h2 class="legal-h2">Registereintrag</h2>
    <p>
      Eingetragen im Handelsregister<br />
      Registergericht: [Amtsgericht ...]<br />
      Registernummer: [HRB ...]
    </p>
  </section>

  <section class="legal-section">
    <h2 class="legal-h2">Umsatzsteuer-Identifikationsnummer</h2>
    <p>
      Gemäß § 27 a Umsatzsteuergesetz:<br />
      [USt-IdNr.: DE ...]
    </p>
  </section>

  <section class="legal-section">
    <h2 class="legal-h2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
    <p>
      [Name]<br />
      [Anschrift]
    </p>
  </section>

  <p class="legal-stand"><strong>Stand: [Datum]</strong></p>
</article>
